import React from "react";
import "./TaskFott.css";

const TaskFott = () => {
  return (
    <div className="fott">
      <a href="https://alejandro-carrillo.web.app/">
        Alejandro Carrillo
      </a>
    </div>
  );
};

export default TaskFott;
